// ProtectedRoutes.tsx

import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "redux/authSlice";
import routes from "./routes";

const ProtectedRoutes = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  return isAuthenticated ? <Outlet /> : <Navigate to={routes.AdminLogin} />
};

export default ProtectedRoutes;
